import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { PROTECTED, INVOICES } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${INVOICES}`;

export const Route = createFileRoute('/protected/_layout/invoices/_layout/new')(
  {
    ...createSheetRouteOptions(RETURN_URL),
    component: NewInvoiceModal,
  }
);

function NewInvoiceModal() {
  const search = useSearch({ strict: false }) as { subTab?: string };

  // INCOMING fatture (acquisto): usano la creation dialog dell'hub, non
  // l'editor inline. Per OUTGOING / proforma / quotes si renderizza il form
  // editoriale completo come per `/documents/new`.
  if (search.subTab === 'incoming') return null;

  return <DocumentForm subTab={search.subTab} returnUrl={RETURN_URL} />;
}
